import React, { useState } from 'react';
import PropTypes from 'prop-types';
import './FloatingLabel.scss';

const FloatingLabel = (props) => {
  const [focus, setFocus] = useState(false);
  const isFloating = focus || (props.inputValue && props.inputValue.length !== 0);
  const elementClass = isFloating || props.isEdit ? 'float-label floating' : 'float-label';
  const isSmall = props.alwaysSmall ? 'always-small' : '';
  const isBig = props.alwaysBig ? 'always-big' : '';
  return (
    <div className={`${elementClass} ${isSmall} ${isBig} ${props.className ?? ''}`} onBlur={() => setFocus(false)} onFocus={() => setFocus(true)}>
      {props.children}
      <label className='float-label__label' htmlFor={props.inputId}>
        {!!props.shortLabel ? (isFloating ? props.shortLabel : props.label) : props.label}
      </label>
    </div>
  );
};

FloatingLabel.propTypes = {
  children: PropTypes.element,
  inputId: PropTypes.string,
  label: PropTypes.string,
  shortLabel: PropTypes.string,
  alwaysSmall: PropTypes.bool,
  alwaysBig: PropTypes.bool,
};

export default FloatingLabel;
